import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loading: null,
		activeTab: 0, // 当前激活的tab索引
	},
	getters: {
		getActiveTab: state => state.activeTab,
	},
	mutations: {
		SET_ACTIVE_TAB(state, tabIndex) {
			state.activeTab = tabIndex;
		},
	},
	actions: {
		setActiveTab({ commit }, tabIndex) {
			commit('SET_ACTIVE_TAB', tabIndex);
		},
	},
	modules: {},
});
